module.exports = __webpack_public_path__ + "media/27.2373f805.mp3";